const e = ["pricing-rule"], l = {
  all: e,
  details: () => [...e, "detail"],
  detail: (i) => [...e, "detail", i]
};
export {
  l as pricingRuleKeys
};
//# sourceMappingURL=pricing-rule-keys.js.map
